// extracted by mini-css-extract-plugin
export default {"imgThumbNail":"Image_imgThumbNail__D9xGM","imgHidden":"Image_imgHidden__4zj+X","imgPlaceholder":"Image_imgPlaceholder__91M4C"};